<template>
    <v-sheet class="mx-auto pt-4 " width="300" color="#212121">
    <div class="d-flex justify-end">
        <v-btn class="ma-0 pa-0" icon @click="close">
            <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
    </div>

        <v-form @submit.prevent>
            <!-- <v-text-field v-model="goToPointStrategy" label="Status Go To Point" disabled></v-text-field> -->
            <v-text-field v-model="coordinates" label="Coordenadas" disabled></v-text-field>
            <v-text-field type="number" v-model.number="altitude" :rules="rules" label="Altura"></v-text-field>
            <v-text-field v-if="goToPointStrategy == 1" type="number" v-model.number="altitudeRTH" :rules="rulesRTH" label="Altura de RTH"></v-text-field>
            <v-text-field v-if="goToPointStrategy == 1" type="number" v-model.number="altitudeSecureTakeoff" :rules="rulesSecureTakeOff" label="Altura de despegue"></v-text-field>
            
            <!-- <v-text-field type="number" v-model.number="altitudeSecureTakeoff" :rules="rules" label="Altura segura de despegue"></v-text-field> -->
            <!-- <v-text-field v-model="requestAltitude" label="Request Altitude" disabled></v-text-field> -->
            <v-btn class="mt-2" @click="goToPoint" type="submit" block>Ir al punto</v-btn>
        </v-form>
    </v-sheet>

</template>

<script setup>
/* eslint-disable */

import { CURRENT_CONFIG, HMIN_CONFIG, HMAX_CONFIG, TAKEOFF_MAX_ALTITUDE, TAKEOFF_MIN_ALTITUDE, RTH_MAX_ALTITUDE, RTH_MIN_ALTITUDE } from '../../../../api/http/config.ts';

import { defineProps, computed, ref } from 'vue'
const props = defineProps({
    event: Object,
    marker: Object,
})
import { storeToRefs } from "pinia";

import useStore from "@/store";
const store = useStore();
const droneSn = store.child_device_sn;
const dockSn = store.device_sn;
import { getDroneTelemetry } from "../../utils/droneTelemetryUtils.js";
import { getDockTelemetry } from "../../utils/dockTelemetryUtils.js";

const { telemetry, droneConnected } = storeToRefs(store);

const telemetryData = computed(() => {
    return telemetry.value
})
/*
const altitude = ref(CURRENT_CONFIG.hmin)
const altitudeRTH = ref(CURRENT_CONFIG.hmin)
const altitudeSecureTakeoff = ref(CURRENT_CONFIG.hmin)
*/
const altitude = ref(HMIN_CONFIG.value)
const altitudeRTH = ref(RTH_MIN_ALTITUDE.value)
const altitudeSecureTakeoff = ref(TAKEOFF_MIN_ALTITUDE.value)

//const hmin = ref(1500)
//const hmax = ref(600)

/*

*/

const close = () => {
    props.marker.setMap(null)
    props.marker.setVisible(false);
    props.marker = null
    
}

const rulesRTH = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        //return (number >= CURRENT_CONFIG.hmin && number <= CURRENT_CONFIG.hmax) || 'El valor debe estar entre ' + CURRENT_CONFIG.hmin +' y ' + CURRENT_CONFIG.hmax;
        return (number >= RTH_MIN_ALTITUDE.value && number <= RTH_MAX_ALTITUDE.value) || 'El valor debe estar entre ' + RTH_MIN_ALTITUDE.value +' y ' + RTH_MAX_ALTITUDE.value;
    }
]

const rulesSecureTakeOff = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        return (number >= TAKEOFF_MIN_ALTITUDE.value && number <= TAKEOFF_MAX_ALTITUDE.value) || 'El valor debe estar entre ' + TAKEOFF_MIN_ALTITUDE.value + ' y ' + TAKEOFF_MAX_ALTITUDE.value;
    }
]

//const altitudeSecureTakeoff = ref(100)
const rules = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        return (number >= HMIN_CONFIG.value && number <= HMAX_CONFIG.value) || 'El valor debe estar entre ' + HMIN_CONFIG.value + ' y ' + HMAX_CONFIG.value;
    }
]

const coordinates = computed(() => {
    return Number(props.event.latLng.lat()).toFixed(6) + ", " + Number(props.event.latLng.lng()).toFixed(6);
})

const exist = (data) => {
    return data !== undefined && data !== null;
};


const dockStatus = computed(() => {
    try {
        return telemetry.value[dockSn]["osd_telemetry"]["data"]["mode_code"]
    } catch {
        return -1
    }
});

const dockASL = computed(() => {
    try {
        return Math.floor(telemetry.value[dockSn]["osd_telemetry"]["data"]["height"])
    } catch {
        return -1
    }
})

const droneStatus = computed(() => {
    try {
        return telemetry.value[droneSn]["osd_telemetry"]["data"]["mode_code"]
    } catch {
        return -1
    }
});

const requestAltitude = computed(() => {
    return dockASL.value + altitude.value
})

const getTakeoffToPointBody = () => {
    return {
        target_height: requestAltitude.value,
        target_latitude: Number(props.event.latLng.lat()).toFixed(12),
        target_longitude: Number(props.event.latLng.lng()).toFixed(12),
        security_takeoff_height: altitudeSecureTakeoff.value,
        max_speed: 15,
        rc_lost_action: 2,
        rth_altitude: HMIN_CONFIG.value,
        exit_wayline_when_rc_lost: 1,
        commander_mode_lost_action: 1,
        commander_flight_mode: 1,
        commander_flight_height: HMIN_CONFIG.value, // Parametro de seguridad de 150m
        rth_mode: 1,
    }
}

const getFlyToPoint = () => {
    return {
        max_speed: 15,
        points: [{
            latitude: Number(props.event.latLng.lat()).toFixed(12),
            longitude: Number(props.event.latLng.lng()).toFixed(12),
            height: requestAltitude.value,
        }],
    }
}

// eslint-disable-next-line
const goToPointStrategy = computed(() => {
    const droneValid = droneStatus.value == 3 || droneStatus.value == 8 || droneStatus.value == 15
    if (dockStatus.value == 0) {
        return 1
    } else if (dockStatus.value == 4 && droneValid) {
        return 2
    } else {
        return -1
    }
})


import { postTakeoffToPoint, postFlyToPoint } from '../../../../api/drone-control/drone.ts';
import { registryGoTo } from '@/services/gotoService.js'

const goToPoint = async () => {
    const droneValid = droneStatus.value == 3 || droneStatus.value == 8 || droneStatus.value == 15
    if (dockStatus.value == 0) {
        let gotoPayload = getTakeoffToPointBody()
        gotoPayload["dock_sn"] = dockSn;
        gotoPayload["drone_sn"] = droneSn;
        gotoPayload["token"] = localStorage.getItem('x-auth-token')
        console.warn(gotoPayload)
        try {
        const r2 = await registryGoTo(gotoPayload)
        console.warn("GoTo Registry response")
        console.warn(r2)
        } catch(e) {
            console.warn ("Go TO Error")
            console.warn(e)
        }
        
        
        const result = await postTakeoffToPoint(dockSn, getTakeoffToPointBody())
        console.warn(result)
        
    } else if (dockStatus.value == 4 && droneValid) {
        const result = await postFlyToPoint(dockSn, getFlyToPoint())
        console.warn(result)
    } else {
        console.warn("Can't go to point")
    }
}

</script>

<style></style>
